import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

export interface OverviewNavItem {
  id: string;
  title: string;
}

@Component({
  selector: 'app-overview-nav-item',
  imports: [
    CommonModule,
    TranslateModule
  ],
  templateUrl: './overview-nav-item.html',
  styleUrl: './overview-nav-item.css'
})
export class OverviewNavItemComponent {
  @Input() navItem!: OverviewNavItem;
  @Input() index!: number;
  @Input() isSelected: boolean = false;
  @Output() navItemSelected = new EventEmitter<number>();

  onNavItemClick(): void {
    this.navItemSelected.emit(this.index);
  }
}
